import axiosInstance from "./axiosInstance";

const pharmacyLedgerService = {
  getSummary: async (params = {}) => {
    try {
      const { data } = await axiosInstance.get("pharmacyLedger/summary", { params });
      return data;
    } catch (error) {
      console.error("Error fetching ledger:", error);
      return { success: false, data: [], totals: {} };
    }
  },
};

export default pharmacyLedgerService;
